import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { ForceResetPassword } from '@arc/arc-shared-frontend';

@Component({
  selector: 'app-authentication-forceresetpassword-container',
  styleUrls: ['./forceresetpassword.container.component.scss'],
  templateUrl: './forceresetpassword.container.component.html'
})
export class ForceResetPasswordContainerComponent implements OnInit {
  msgs = [];
  @Output() onResetPasswordClicked = new EventEmitter<any>();

  constructor(private store: Store<any>, private route: ActivatedRoute) {}

  ngOnInit() {}

  onResetPasswordClick($event) {
    this.onResetPasswordClicked.emit($event);
    let isExternal = this.route.snapshot.paramMap.get('isExternal');
    let tenantId = this.route.snapshot.paramMap.get('tenantId');
    let payload;
    if (isExternal) {
      payload = { newPassword: $event, tenantId: tenantId, isExternal: true };
    } else {
      payload = { newPassword: $event };
    }
    this.store.dispatch(new ForceResetPassword(payload));
    // this.store.dispatch(new ResetPassword($event));
  }
}
